module.exports = __webpack_public_path__ + "static/media/AI.d10e592f.png";